import React from 'react'
import Icon from './Icon'
import Name from './Name'
import When from './When'
import PropTypes from 'prop-types'

const Status = ({ status, name, className, index }) => {
  return (
    <li className='pos-relative' key={index}>
      <div className='row'>
        <div className='col-auto'>
          <Icon {...status} />
        </div>
        <div className='col'>
          <Name {...status} />
          <When {...status} />
        </div>
      </div>
    </li>
  )
}

Status.propTypes = {
  status: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  index: PropTypes.number
}
export default Status



// WEBPACK FOOTER //
// ./src/App/Header/Tracking/Item/Status/Status.js